import http from "../../axios";
import store from "../../store/store";

const ApiService = {
  baseUrl: "/api/v1/campaigns/",
  get(url) {
    return http.get(this.baseUrl + url);
  },
  post(url, payload) {
    return http.post(this.baseUrl + url, payload);
  },
  patch(url, payload) {
    return http.patch(this.baseUrl + url, payload);
  },
  delete(url, payload) {
    return http.delete(this.baseUrl + url, payload);
  }
};

export const GlobalService = {
  getTasks() {
    return ApiService.get(`${store.getters.campaign.id}/users/tasks`);
  },
  getUserProfile() {
    return ApiService.get(`${store.getters.campaign.id}/users/info`);
  },
  getSurveyProfile() {
    return ApiService.get(`${store.getters.campaign.id}/users/surveyProfile`);
  },
  uploadAvatar(avatar) {
    return ApiService.post(`${store.getters.campaign.id}/users/avatar`, avatar);
  },
  deleteAccount() {
    return ApiService.delete(`${store.getters.campaign.id}/users`);
  },
  undoDeleteAccount() {
    return ApiService.get(`${store.getters.campaign.id}/users/undelete`);
  },
  updateProfileAttributes(attributes) {
    return ApiService.post(
      `${store.getters.campaign.id}/users/profile/attributes`,
      attributes
    );
  },
  updateConsents(attributes) {
    return ApiService.patch(
      `${store.getters.campaign.id}/users/agreements`,
      attributes
    );
  }
};

export const MissionService = {
  getQuiz(id) {
    return ApiService.get(`${store.getters.campaign.id}/instantwins/${id}`);
  },
  getQuizQuestion(id) {
    return ApiService.get(
      `${store.getters.campaign.id}/instantwins/${id}/question`
    );
  },
  getQuizPoints(id) {
    return ApiService.get(
      `${store.getters.campaign.id}/instantwins/${id}/users/points`
    );
  },
  sendQuizAnswer(quizId, payload) {
    return ApiService.post(
      `${store.getters.campaign.id}/instantwins/${quizId}/answer`,
      payload
    );
  },
  startQuizQuestions(id) {
    return ApiService.get(`${store.getters.campaign.id}/instantwins/${id}`);
  },
  getSurveyQuestions(id) {
    return ApiService.get(
      `${store.getters.campaign.id}/surveys/${id}/questions`
    );
  },
  getPredicitonQuestions(id) {
    return ApiService.get(
      `${store.getters.campaign.id}/predictions/${id}/questions`
    );
  },
  sendSurveyAnswers(id, payload) {
    return ApiService.post(
      `${store.getters.campaign.id}/surveys/${id}/answers`,
      payload
    );
  },
  sendPredictionAnswers(id, payload) {
    return ApiService.post(
      `${store.getters.campaign.id}/predictions/${id}/submissions`,
      payload
    );
  },
  getVideo(id) {
    return ApiService.get(`${store.getters.campaign.id}/videos/${id}`);
  },
  markVideoAsSeen(id) {
    return ApiService.post(`${store.getters.campaign.id}/videos/${id}/seen`);
  },
  playInstantwinRandom(id) {
    return ApiService.post(
      `${store.getters.campaign.id}/instantwinsRandom/${id}/play`
    );
  }
};

export default ApiService;
